<template>
  <v-layout ref="origin" style="overflow: auto; clear:both; max-height:calc(100vh - 17px);height:calc(100vh - 64px); cursor: grab;position: relative;padding-top:200px;">
    <v-snackbar
      class="mt-5"
      style="position:fixed;"
      v-if="localToast"
      v-model="localToast"
      :color="localToast.color"
      multi-line
      top
      right
      :timeout="localToast.timeout"
      >
        {{localToast.text}}
    </v-snackbar>
    <!-- /*************************** */ -->
<v-dialog v-model="userDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add a person</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <center>
              <v-hover v-slot:default="{ hover }">
              <v-btn icon height="150" width="150" @click="" ripple color="grey">
                <v-icon transition="fade-transition" color="black" v-if="hover" size="100">fas fa-cloud-upload-alt</v-icon>
                <v-icon transition="fade-transition" color="black" v-else size="100">fas fa-user</v-icon>
              </v-btn> 
              </v-hover>
                </center>
              </v-col>
              <v-col v-if="Array.isArray(dialogReferer)" cols="12" sm="12" md="12">
                <v-text-field v-model="newPosition" label="Position*" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="newPerson.firstName" label="First Name*" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="newPerson.lastName"
                  label="Last Name*"
                  hint="example of persistent helper text"
                  persistent-hint
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Email" v-model="newPerson.email"></v-text-field>
              </v-col>
              <v-col cols="12">
        <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="newPerson.hireDateString"
            label="Hire Date"
            prepend-inner-icon="fa fa-calendar"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
          <v-date-picker v-model="newPerson.hireDateString" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
          </v-date-picker>
      </v-menu>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeUserDialog">Close</v-btn>
          <v-btn color="blue darken-1" text @click="createPerson">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
<!-- /************** */ -->
    <v-dialog v-model="positionDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add a Role</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field v-model="newRole.jobTitle" label="Job Title*" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    ref="selectedPersonForNewRole"
                    item-value="id"
                    v-model="selectedPersonForNewRoleId"
                    :loading="loading"
                    :items="people"
                    item-text="displayName"
                    flat
                    label="Employee"
                  >
                  <template v-slot:append-outer>
                    <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-if="newRole.person" v-on="on" @click="newRole.person = null" icon height="32" width="32">
                        <v-icon color="red" size="16">fas fa-times</v-icon>
                      </v-btn>
                    </template>
                    <span>Remove employee</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item="data">
                    <v-list-item
                        @click="() => personSelectedForNewRole(data.item)"
                      >
                      <v-list-item-action>
                        <v-avatar size="30">
                          <v-img
                          :src="data.item.imageUrl"
                          ></v-img>
                        </v-avatar>        
                        </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{data.item.firstName}} {{data.item.lastName}} <v-icon size="16" v-if="data.item.indexArray">fas fa-project-diagram</v-icon></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:prepend-inner>
                  <v-avatar size="30" v-if="newRole.person && newRole.person.imageUrl">
                    <v-img
                    :src="newRole.person.imageUrl"
                    ></v-img>
                  </v-avatar> 
                  </template>
                  
                  <template v-slot:prepend-item>
                      <v-list-item
                        ripple
                        @click="() => openUserDialogWithReferer('role')"
                      >
                        <v-list-item-action>
                          <v-icon color="green">fas fa-plus-circle</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>Add a person</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          No one found.
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
              </v-col>
              <v-col cols="6" sm="6">
                  <v-autocomplete
                    ref="selectedDepartmentForNewRole"
                    item-value="id"
                    :value="selectedDepartmentForNewRoleId"
                    :loading="loading"
                    :items="departments"
                    item-text="name"
                    flat
                    label="Department"
                  >
                  <template v-slot:append-outer>
                    <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-if="newRole.department || newRole.departmentObj" v-on="on" @click="newRole.department = null; newRole.departmentObj = null; departmentUpdatedCount++;" icon height="32" width="32">
                        <v-icon color="red" size="16">fas fa-times</v-icon>
                      </v-btn>
                    </template>
                    <span>Remove Department</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item="data">
                    <v-list-item
                        @click="() => {newRole.departmentObj = data.item; newRole.department = data.item.name; $refs.selectedDepartmentForNewRole.isMenuActive = false; departmentUpdatedCount++;}"
                      >
                      <v-list-item-action>
                        <v-avatar size="30" :style="{'background-color': data.item.color}">
                        </v-avatar>        
                        </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{data.item.name}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:prepend-inner>
                  <v-avatar size="30" v-if="newRole.departmentObj && newRole.departmentObj.color" :style="{'background-color': newRole.departmentObj.color}">
                  </v-avatar> 
                  </template>
                  
                  <template v-slot:prepend-item>
                      <v-list-item
                        disabled
                        ripple
                        @click=""
                      >
                        <v-list-item-action>
                          <v-icon color="grey">fas fa-plus-circle</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>Add a department (in development)</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          No department found.
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="newRole.budgetedHours" label="Budgeted Hours" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="newRole.salary" label="Salary" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closePositionDialog">Close</v-btn>
          <v-btn color="blue darken-1" text @click="createRole">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /************* */ -->
    <v-card v-if="miniSidebar" :style="{ 'position': 'fixed', 'top': '100px', 'right': `${miniSidebar ? 80 : 0}px`, 'z-index': 90, 'padding': '10px'}">
        <v-hover v-slot:default="{ hover }">
        <v-flex justify-space-between style="flex-wrap: nowrap">
        <v-icon>fas fa-search</v-icon>
        <span class="ma-2">{{Math.round(100 * mappingPanZoom)}}%</span>
        </v-flex>
        </v-hover>
    </v-card>
    <v-navigation-drawer
      permanent
      :mini-variant.sync="miniSidebar"
      right
      absolute
      width="350"
      style="z-index:100; position: fixed; margin-top: 64px"
    >
    <v-layout  @mouseover="(e) => setMiniSidebar(false, e)"
      @mouseleave="(e) => setMiniSidebar(true, e)" style="height: 100%; width: 100%">
    <v-card v-if="selectedCard && !miniSidebar" color="basil" style="width: 100%;">
    <v-tabs
      v-model="currentTab"
      background-color="transparent"
      color="basil"
      fixed-tabs
    >
      <v-tab
        v-for="tab in tabs"
        v-if="(tab.name === 'employee' && selectedCard && selectedCard.person) || tab.name !== 'employee' "
        :key="tab.name  + '-tab'"
      >
        <v-icon class="mr-3">{{tab.icon}}</v-icon>
        {{ tab.name === 'employee' && selectedCard && selectedCard.person && selectedCard.person.firstName ? selectedCard.person.firstName : tab.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentTab">
      <v-tab-item
        v-for="tab in tabs"
        :key="tab.name + '-tab-item'"
      >
        <v-card
         v-if="tab.name==='position'"
          flat
        >
          <v-card-text>Position Tab</v-card-text>
    <v-autocomplete
      ref="selectPerson"
      item-value="id"
      v-model="selectedPersonId"
      :loading="loading"
      :items="people"
      item-text="displayName"
      class="mx-4"
      flat
      label="Employee"
    >
    <template v-slot:append-outer>
      <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-if="selectedCard && selectedCard.person" v-on="on" @click="removePersonFromCard" icon height="32" width="32">
          <v-icon color="red" size="16">fas fa-times</v-icon>
        </v-btn>
      </template>
      <span>Remove employee</span>
      </v-tooltip>
    </template>
    <template v-slot:item="data">
      <v-list-item
          :disabled="data.item.isSelected"
          @click="() => personChanged(data.item)"
        >
        <v-list-item-action>
          <v-avatar size="30">
            <v-img
            :src="data.item.imageUrl"
            ></v-img>
          </v-avatar>        
          </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{data.item.firstName}} {{data.item.lastName}} <v-icon size="16" v-if="data.item.indexArray">fas fa-project-diagram</v-icon></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-slot:prepend-inner>
     <v-avatar size="30">
            <v-img
            v-if="selectedCard && selectedCard.person && selectedCard.person.imageUrl"
            :src="selectedCard.person.imageUrl"
            ></v-img>
          </v-avatar> 
    </template>
    
    <template v-slot:prepend-item>
        <v-list-item
          ripple
          @click="() => openUserDialogWithReferer('sidebar')"
        >
          <v-list-item-action>
            <v-icon color="green">fas fa-plus-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Add a person</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>
            No one found.
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-autocomplete>
    <v-btn icon>
      <v-icon>mdi-dots-vertical</v-icon>
    </v-btn>
        </v-card>
        <v-card
         v-else-if="tab.name==='employee'"
          color="basil"
          flat
        >
          <v-card-text>Employee Tab</v-card-text>
        </v-card>
          <v-card
         v-else
          color="basil"
          flat
        >
          <v-card-text>ERROR TAB - PLEASE REPORT</v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
    </v-layout>
    </v-navigation-drawer>
          <v-card class="hidden-sm-and-down" :style="{ 'position': 'fixed', 'top': '120px', 'right': '30%', 'width': '40%', 'z-index': 90, 'padding': '10px'}">
           <v-slider
           @change="sliderChanged"
           style="cursor:pointer"
            :tick-labels="events"
            :value="3"
            min="0"
            max="3"
            ticks="always"
            tick-size="4"
            >
            <template v-slot:thumb-label="props">
              {{ date(props.value) }}
            </template>
          </v-slider>
          </v-card>
          
          <v-card v-if="showCallToAction && !submittedCallToAction" :style="{'pa-5': $vuetify.breakpoint.mdAndUp, 'position': 'fixed', 'bottom': '100px', 'left': '50px', 'z-index': 101}">
          <v-card-title style="background-color: rgba(249, 191, 59, 1); margin-bottom:20px; padding-top:30px" class="justify-space-between">
            <span :class="{'subtitle-2': $vuetify.breakpoint.smAndDown, 'headline': $vuetify.breakpoint.mdAndUp}" style="display:block;">
              <b>Coming Soon!</b> Sign up now for access to the exclusive beta!
            </span>
            <v-btn icon  style="position: absolute; right: 10px; top: 0px" @click="toggleShow">
            <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-card-title>
          <v-flex row justify-space-around style="width:90%;height:100%" ml-3 align-top>
          <v-text-field @keyup.enter="submitCallToAction" v-model="ctaEmail" label="Your Email" hint="We promise to only email you about Org Owl!" persistent-hint type="email" style="max-width: 400px;" solo outlined filled>
          </v-text-field>
          <v-btn class="pulseButton" :loading="loading" @click="submitCallToAction" style="max-height: 100%; background-color:rgba(249, 191, 59, 1)" height="56" >
            Sign Up
          </v-btn>
          </v-flex>
        </v-card>
        <v-btn class="pulseButton" v-else-if="!submittedCallToAction" large :style="{'position': 'fixed', 'bottom': '70px', 'left': '10px', 'z-index': 90, 'background-color':  'rgba(249, 191, 59, 1)'}" @click="toggleShow">
          <span style="">
            I'm interested!
          </span>
        </v-btn>
      <ChartBox2 ref="main" :panzoomInstance=instance :currentX=currentX :currentY=currentY :scale=panzoomScale :mappingScale=panzoomScale :whichPageToShow=mappingPanZoom :chart="selectedChart" :id="0" :ignoreMargin="false" :top="0" :left="0" :chartUUID="selectedChart.id" :indexArray=[selectedChartIndex] :functions=modifiedFunctions :redrawAllLines="debounce(this.recursiveDrawLines, 300)" :moveInProgress=moveInProgress
      style="">
    </ChartBox2>
  </v-layout>
</template>
<script>
import { dragscroll } from 'vue-dragscroll'
import panzoom  from 'panzoom'
import ChartBox2 from './ChartBox2';
import * as _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';


import axios from "axios";
axios.defaults.baseURL = "https://todotrackerapi.azurewebsites.net/";
export default {
    components: {ChartBox2},
    props: ['org', 'functions', 'moveInProgress', 'clickedCard', 'peopleForCharts', 'departments'],
    mounted() {
      window.addEventListener('resize', this.recursiveDrawLines)
      this.interval = window.setInterval(this.recursiveDrawLines, 30000);
      this.selectedChart = this.org.chart[3]
      this.instance = panzoom(this.$refs.main.$el, {
        bounds: true,
        boundsPadding: 0.6,
        zoomSpeed: 0.05,
        maxZoom: 1.5,
        minZoom: 0.1,
        onTouch: function(e) {
          if (e.target && e.target.className && e.target.className.indexOf && e.target.className.indexOf('icon') >=0) {
            return false
          }
        }
      })
      let debouncedRedraw = this.debounce(this.recursiveDrawLines, 300)

      if (this.$vuetify.breakpoint.smAndDown) {
        this.instance.zoomAbs(0,0,1.0)
        this.mappingPanZoom = 1.0
      } else {
        this.instance.zoomAbs(0,0,1)
        this.mappingPanZoom = 1.0
      }
      this.instance.on('zoom', (e) => {
        let transform = e.getTransform()
        this.mappingPanZoom = transform.scale
        this.currentX = transform.x
        this.currentY = transform.y
        debouncedRedraw()
      })
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.recursiveDrawLines)
      window.clearInterval(this.interval)
    },
    directives: {
      'dragscroll': dragscroll
    },
    data: function() {
      return {
        personRoleUpdatedCount: 0,
        departmentUpdatedCount: 0,
        newRole:{...this.newRoleDefault},
        newRoleDefault: {
          jobTitle: '',
          department: '',
          departmentObj: null,
          budgetedHours: '',
          salary: '',
          person: null,
          reportsHorizontal: true,
          expanded: true,
          reports: [],
        },
        dialogReferer: null,
        positionDialogReferer: null,
        newPerson: {...this.newPersonDefault},
        newPersonDefault: {
          id: '',
          firstName: '',
          lastName: '',
          hireDateString: new Date().toISOString().substr(0, 10),
          imageUrl: require('../assets/TomMcGee.jpg'),
          email: ''
        },
        menu: false,
        dateInput: null,
        userDialog: false,
        positionDialog: false,
        currentTab: null,
        // people: [
        //   {name:"Tom McGee", imageUrl: require('../assets/TomMcGee.jpg')},
        //   {name:"Megan Runn", imageUrl: require('../assets/MeganRunn.jpg')},
        //   ],
        tabs: [{name: 'position', text: 'test', icon: 'fas fa-tasks'}, {name: 'employee', text: 'test2', icon: 'fas fa-user-edit'}],
        items: [{
          avatar: require('../assets/LisaHarp.jpg'),
          title: 'Tom McGee',
          active: false,
        },
        {
          avatar: require('../assets/LisaHarp.jpg'),
          title: 'Tom McGee',
          active: false,
        },
               {
          avatar: require('../assets/LisaHarp.jpg'),
          title: 'Tom McGee',
          active: false,
        },       {
          avatar: require('../assets/LisaHarp.jpg'),
          title: 'Tom McGee',
          active: false,
        },       {
          avatar: require('../assets/LisaHarp.jpg'),
          title: 'Tom McGee',
          active: false,
        },       {
          avatar: require('../assets/LisaHarp.jpg'),
          title: 'Tom McGee',
          active: false,
        },
        ],
        selectedCard: null,
        selectedCardIndexArray: null,
        modifiedFunctions: {
          ...this.functions,
          setMiniSidebar: this.setMiniSidebar,
          setSelectedCard: this.setSelectedCard,
          openUserDialogWithReferer: this.openUserDialogWithReferer,
          openPositionDialogWithReferer: this.openPositionDialogWithReferer
        },
        miniSidebar: true,
        interval: null,
        instance: null,
        panzoomScale: 1,
        mappingPanZoom: 1,
        selectedChart: [],
        selectedChartIndex: 3,
        events: [
          'First Hires',
          'Funding',
          'Restructure',
          'Acquired'
        ],
        dates: ['2001', '2004', '2013', '2019'],
        ctaEmail: '',
        loading: false,
        localToast: null,
        showCallToAction: true,
        submittedCallToAction: false,
        scale: (this.$vuetify.breakpoint.smAndDown ? 1.0 : 1.0),
        orgCardHeight: 250,
        orgCardWidth: 500,
        maxLinePointWidth: 0,
        maxLinePointHeight: 0,
        currentX: 0,
        currentY: 0,
      }
    },
    computed: {
      selectedPersonId: {
        // getter
        get: function () {
          if (this.selectedCard && this.selectedCard.person && this.selectedCard.person.id) {
            return this.selectedCard.person.id
          }
          return null
        },
        // setter
        set: function (newValue) {
        }
      },
      selectedPersonForNewRoleId: {
        // getter
        get: function () {
          this.personRoleUpdatedCount;
          if (this.newRole && this.newRole.person && this.newRole.person.id) {
            return this.newRole.person.id
          }
          return 'None'
        },
        // setter
        set: function (newValue) {
        }
      },
      selectedDepartmentForNewRoleId: function(){
        this.departmentUpdatedCount;
        if (this.newRole && this.newRole.departmentObj && this.newRole.departmentObj.id) {
          return this.newRole.departmentObj.id       
        }
      },
      people: function() {
        return this.peopleForCharts[this.selectedChartIndex].map(person => {
          if (this.selectedCard && this.selectedCard.person) {
            return {...person, isSelected: person.id === this.selectedCard.person.id}
          } else {
            return {...person, isSelected: false}
          }
        })
      },
    },
    methods: {
      openUserDialogWithReferer: function(referer) {
        if (referer === 'role' && this.$refs.selectedPersonForNewRole) {
          this.$refs.selectedPersonForNewRole.isMenuActive = false
        }
        this.userDialog = true
        this.dialogReferer = referer
        this.newPerson = {...this.newPersonDefault}
        this.newPosition = null;
      },
      closeUserDialog: function() {
        this.userDialog = false
        this.dialogReferer = null;
        this.newPosition = null;
        this.newPerson = {...this.newPersonDefault}
      },
      openPositionDialogWithReferer: function(referer) {
        this.positionDialog = true
        this.positionDialogReferer = referer
        this.newRole = {...this.newRoleDefault}
        this.newRole.reports = [];
      },
      closePositionDialog: function() {
        this.positionDialog = false
        this.positionDialogReferer = null;
        this.newRole = {...this.newRoleDefault}
        this.newRole.reports = [];
      },
      generateUUID: function() {
        return uuidv4();
      },
      createPerson() {
        if (!this.newPerson.firstName) {
          this.localToast = {
            text: `Error creating the person, first name is a required field!`,
            color: "error",
            timeout: 5000
          }
          return
        }

        if (!this.newPerson.lastName) {
          this.localToast = {
            text: `Error creating the person, last name is a required field!`,
            color: "error",
            timeout: 5000
          }
          return
        }

        this.newPerson.id = this.generateUUID()
        if (this.newPerson.hireDateString) {
          this.newPerson.hireDate = new Date(this.newPerson.hireDateString)
        }
        this.functions.addToAvailablePeople(this.newPerson, this.selectedChartIndex)
         if (this.dialogReferer === 'sidebar') {
          this.personChanged(this.newPerson)
        } else if (this.dialogReferer === 'role') {
          this.newRole.person = this.newPerson; 
        }
        this.closeUserDialog();
        this.newPerson = {...this.newPersonDefault}
      },
      personSelectedForNewRole(val) {
        this.newRole.person = val
        this.personRoleUpdatedCount++;
        if (this.$refs.selectedPersonForNewRole) {
          this.$refs.selectedPersonForNewRole.isMenuActive = false
        }
      },
      personChanged(val) {
        this.functions.setPerson(this.selectedCardIndexArray, val)
        this.setSelectedCard(this.selectedCardIndexArray, true)
        if (val.indexArray) {
          this.functions.setPerson(val.indexArray, null);
        } else {
          this.functions.removeFromAvailablePeople(val.id, this.selectedChartIndex)
        }
        if (this.$refs.selectPerson[0]) {
          this.$refs.selectPerson[0].isMenuActive = false
        }
      },
      createRole() {
        // {
        //   jobTitle: '',
        //   department: '',
        //   departmentObj: null,
        //   budgetedHours: '',
        //   salary: '',
        //   person: null,
        //   reportsHorizontal: true,
        //   expanded: true,
        //   reports: [],
        // }

        if (!this.newRole.jobTitle) {
          this.localToast = {
            text: `Error creating the role, the role must have a job title!`,
            color: "error",
            timeout: 5000
          }
          return
        }
        this.newRole.id = this.generateUUID()
        this.functions.addReport(this.positionDialogReferer, {...this.newRole})
        if (this.newRole.person) {
          let newPersonIndexArray = this.newRole.person.indexArray
          if (newPersonIndexArray) {
            this.functions.setPerson(newPersonIndexArray, null);
          } else {
            this.functions.removeFromAvailablePeople(this.newRole.person.id, this.selectedChartIndex)
          }
            this.newRole.person.indexArray = null
        }
        this.closePositionDialog()
        // this.positionDialogReferer
      },
      removePersonFromCard() {
        if (this.selectedCard && this.selectedCard.person) {
          this.functions.addToAvailablePeople(this.selectedCard.person, this.selectedChartIndex)
        }
        this.functions.setPerson(this.selectedCardIndexArray, null)
        this.setSelectedCard(this.selectedCardIndexArray, true)
        if (this.$refs.selectPerson[0]) {
          this.$refs.selectPerson[0].isMenuActive = false
        }
      },
      findPerson(ia) {
        let indexArray = [...ia]
        let chartIndex = indexArray.shift()
        let chart = this.selectedChart
        indexArray.forEach(index => {
            chart = chart.reports[index]
        })
        return chart;
      },
      setMiniSidebar(val, e) {
        let node = e.toElement || e.relatedTarget;
        if (node && node.className && node.className.indexOf && node.className.indexOf("v-list") >= 0 || (val && this.$refs.selectPerson && this.$refs.selectPerson[0] && this.$refs.selectPerson[0].isMenuActive)) {
        } else {
          this.miniSidebar = val;
        }
      },
      setSelectedCard(indexArray, dontClose = false) {
        if (_.isEqual(this.selectedCardIndexArray, indexArray) && !dontClose && !this.miniSidebar) {
          this.selectedCardIndexArray = null;
          this.selectedCard = null;
          this.miniSidebar = true
        } else {
          this.selectedCardIndexArray = indexArray;
          let personClone = {...this.findPerson(indexArray)}
          personClone.reports = [];
          this.selectedCard = personClone;
          this.miniSidebar = false
        }
      },
      date (val) {
        return this.dates[val]
      },
      sliderChanged:  function (val) { 
        this.selectedChart = this.org.chart[val]
        this.selectedChartIndex = val
        this.selectedCardIndexArray = null
        this.selectedCard = null
        this.miniSidebar = true
        this.instance.moveTo(0, 0);
      },
      get: function(uri, data = {}) {
        if (Object.keys(data).length > 0) {
          uri = `${uri}`;
        }

        return axios.get(uri, {
          headers: {},
          withCredentials: false
        });
      },
      post: function (uri, data) {
        return axios.post(uri, data, {
          headers: {'Content-Type': 'application/json'},
          withCredentials: false
        })
      },
      submitCallToAction: async function() {
        if (this.ctaEmail.length > 3 && this.ctaEmail.indexOf('@') > 0) {
          this.loading=true
          this.post('/api/OrgOwl/ImInterested', {'Email': this.ctaEmail, 'Comment': ''}).then(() => {
          this.submittedCallToAction = true
          this.localToast = {
            text: `Success! Looking forward to chatting!`,
            color: "success",
            timeout: 5000
          }
          }).catch(() => {
          this.localToast = {
            text: `Error processing your request, please email Support@StudiedSolutions.com`,
            color: "error",
            timeout: 5000
          }
          }).finally(() => {
            this.loading=false
          })
        } else {
          this.localToast = {
            text: `Please enter a valid email!`,
            color: "error",
            timeout: 5000
          }
        }
      },
      increaseScale: function() {
        if (this.scale < 1.5) {
          this.scale = this.scale + 0.05
        }
      },
      decreaseScale: function() {
        if (this.scale > this.minZoom) {
          this.scale = this.scale - 0.05
        }
      },
      toggleShow: function() {
        this.showCallToAction = !this.showCallToAction
      },
      recursiveDrawLines: async function() {
        let nodes = this.$refs.main
        nodes.incrementReportsUpdatedCount()
        nodes.drawLines()
      },
      debounce: function (func, wait, immediate) {
  var timeout;

  // This is the function that is actually executed when
  // the DOM event is triggered.
  return function executedFunction() {
    // Store the context of this and any
    // parameters passed to executedFunction
    var context = this;
    var args = arguments;

    // The function to be called after 
    // the debounce time has elapsed
    var later = function() {
      // null timeout t o indicate the debounce ended
      timeout = null;

      // Call function now if you did not on the leading end
      if (!immediate) func.apply(context, args);
    };

    // Determine if you should call the function
    // on the leading or trail end
    var callNow = immediate && !timeout;
	
    // This will reset the waiting every function execution.
    // This is the step that prevents the function from
    // being executed because it will never reach the 
    // inside of the previous setTimeout  
    clearTimeout(timeout);
	
    // Restart the debounce waiting period.
    // setTimeout returns a truthy value (it differs in web vs node)
    timeout = setTimeout(later, wait);
	
    // Call immediately if you're dong a leading
    // end execution
    if (callNow) func.apply(context, args);
  };
}
    }
}
</script>

<style lang="scss" scoped>

@keyframes shadow-pulse
{
     0% {
          box-shadow: 0 0 0 0px rgba(249, 191, 59, 0.5);
     }
     100% {
          box-shadow: 0 0 0 35px rgba(249, 191, 59, 0);
     }
}

.pulseButton {
   animation: shadow-pulse 2s infinite;
}

</style>
